module.exports = __webpack_public_path__ + "img/kefu3.0a411fdc.png";